import { createApi } from "element-plus-admin/utils/create-api";

export const publicAccountsApi = createApi({
  url: "/public/accounts",
});
